import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

function Testimonial() {
  const { t } = useTranslation(["Common"]);

  const testimonialData = [
    { name: "John Doe", message: t("Home.section4.div.p") },
    { name: "Jane Smith", message: t("Home.section4.div.p2") },
    // Add more testimonial data as needed
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 9000,
    pauseOnHover: true,
    beforeChange: (current, next) => {
      if (next < current) {
        // Prevent moving backward
        return false;
      }
    },
  };

  return (
    <div className="testimonial-wrapper">
      <div className="testimonial-banner ">
        {/* Add your background image or relevant styling here */}
      </div>
      <div className="  ps-12 lg:ps-0 -mt-96  mb-4 h-96 bg-black opacity-80 pt-6 -z-50  ">
        <p className=" text-white flex justify-center mt-12 text-xl mb-9">{t("Home.section4.div.h3")}</p>
        <Slider {...settings}>
          {testimonialData.map((testimonial, index) => (
            <div key={index} className="testimonial-slide text-center z-50 text-white   ">
              <p className="text-xl mb-3 font-bold text-white">{testimonial.name}</p>
              
              <p className=" lg:w-1/2 m-auto flex justify-center text-center">{testimonial.message}</p>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Testimonial;
